import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import CeramicCoating from "@/pages/CeramicCoating";
import PaintCorrection from "@/pages/PaintCorrection";
import About from "@/pages/About";
import Gallery from "@/pages/Gallery";
import ContactPage from "@/pages/ContactPage";
import { AdminLogin, AdminDashboard, ProtectedAdmin } from "@/pages/Admin";

function SiteLayout({ children }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
    </>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); delete window.__lenis; };
  }, []);

  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<SiteLayout><Home /></SiteLayout>} />
            <Route path="/services" element={<SiteLayout><Services /></SiteLayout>} />
            <Route path="/ceramic-coating" element={<SiteLayout><CeramicCoating /></SiteLayout>} />
            <Route path="/paint-correction" element={<SiteLayout><PaintCorrection /></SiteLayout>} />
            <Route path="/about" element={<SiteLayout><About /></SiteLayout>} />
            <Route path="/gallery" element={<SiteLayout><Gallery /></SiteLayout>} />
            <Route path="/contact" element={<SiteLayout><ContactPage /></SiteLayout>} />
            <Route path="/book" element={<SiteLayout><ContactPage /></SiteLayout>} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<ProtectedAdmin><AdminDashboard /></ProtectedAdmin>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-center" theme="dark" toastOptions={{ style: { background: "#0F0F0F", border: "1px solid rgba(255,255,255,0.1)", color: "#fff" } }} />
      </div>
    </HelmetProvider>
  );
}

export default App;
